import { render } from "./AddToOrderBtn.vue?vue&type=template&id=85f2975e"
import script from "./AddToOrderBtn.vue?vue&type=script&lang=js"
export * from "./AddToOrderBtn.vue?vue&type=script&lang=js"

import "./AddToOrderBtn.vue?vue&type=style&index=0&id=85f2975e&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QField from 'quasar/src/components/field/QField.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QInnerLoading,QSpinner,QBtn,QInput,QList,QItem,QRadio,QField});
